const resourceCenter = {
  'Bank calculator': 'Calculadora del banco',
  'Document published. Users in this distributor workspace can view it.':
    'Documento publicado. Los usuarios de este distribuidor pueden verlo.',
  'Distributor Resources & Tools': 'Recursos y herramientas del distribuidor',
  'Publish for this distributor': 'Publicar para este distribuidor',
  'I reviewed this processed document and its description. It contains general resources, no patient or private clinic records, and can be shared with users in this distributor workspace.':
    'Revisé este documento procesado y su descripción. Contiene recursos generales, sin datos de pacientes ni registros privados de clínicas, y puede compartirse con los usuarios de este distribuidor.',
  '{count} piece \u00b7 {area} cm\u00b2 total': '{count} pieza \u00b7 {area} cm\u00b2 en total',
  'Your session changed. Sign in again to load your size defaults.':
    'Su sesi\u00f3n cambi\u00f3. Inicie sesi\u00f3n de nuevo para cargar sus preferencias de tama\u00f1o.',
  'Find sizes by area': 'Encuentre tama\u00f1os por \u00e1rea',
  'Enter the area you need. We compare sizes within your selected product.':
    'Ingrese el \u00e1rea que necesita. Comparamos tama\u00f1os del producto seleccionado.',
  'Area needed (cm\u00b2)': '\u00c1rea necesaria (cm\u00b2)',
  'Enter an area greater than 0 and up to 10,000 cm\u00b2, with no more than two decimal places.':
    'Ingrese un \u00e1rea mayor que 0 y de hasta 10,000 cm\u00b2, con un m\u00e1ximo de dos decimales.',
  'Exclude sizes': 'Excluir tama\u00f1os',
  'Checked sizes will not be suggested. Applies to every product.':
    'No se sugerir\u00e1n los tama\u00f1os marcados. Se aplica a todos los productos.',
  'No verified sizes are available.': 'No hay tama\u00f1os verificados disponibles.',
  'Save as my defaults': 'Guardar mis preferencias',
  'Your size defaults are saved.': 'Sus preferencias de tama\u00f1o se han guardado.',
  'Your defaults changed elsewhere. Reload saved defaults before saving again.':
    'Sus preferencias cambiaron en otro lugar. Recargue las preferencias guardadas antes de volver a guardar.',
  'Saving could not be confirmed. Reload saved defaults before saving again.':
    'No se pudo confirmar que se guardaran. Recargue las preferencias guardadas antes de volver a guardar.',
  'Reload saved defaults': 'Recargar preferencias guardadas',
  'Size Finder defaults': 'Preferencias del buscador de tama\u00f1os',
  'Saved for your account across browsers. You can change these anytime.':
    'Se guardan para su cuenta en todos los navegadores. Puede cambiarlas cuando quiera.',
  'Could not load products and your saved size defaults. Please retry.':
    'No se pudieron cargar los productos y sus preferencias de tama\u00f1o. Int\u00e9ntelo de nuevo.',
  'Loading size defaults\u2026': 'Cargando preferencias de tama\u00f1o\u2026',
  'Suggested combination': 'Combinaci\u00f3n sugerida',
  '{count} pieces \u00b7 {area} cm\u00b2 total': '{count} piezas \u00b7 {area} cm\u00b2 en total',
  'Area requested: {area} cm\u00b2 \u00b7 Excess: {excess} cm\u00b2':
    '\u00c1rea solicitada: {area} cm\u00b2 \u00b7 Exceso: {excess} cm\u00b2',
  '{quantity} \u00d7 {size}': 'Cantidad: {quantity} \u00d7 {size}',
  '{area} cm\u00b2 per piece': '{area} cm\u00b2 por pieza',
  'Nominal sheet: {size}. Quantity: {quantity}.':
    'L\u00e1mina nominal: {size}. Cantidad: {quantity}.',
  'Fewest pieces first, then least excess area. Each piece is no larger than your entered area.':
    'Primero la menor cantidad de piezas, luego el menor exceso de \u00e1rea. Ninguna pieza supera el \u00e1rea ingresada.',
  'Checking your area\u2026': 'Comprobando el \u00e1rea\u2026',
  'No eligible size combination': 'No hay una combinaci\u00f3n de tama\u00f1os elegible',
  'Your size combination appears here': 'Su combinaci\u00f3n de tama\u00f1os aparece aqui',
  'Try allowing more sizes or review the product instructions. We will not substitute another product.':
    'Intente permitir m\u00e1s tama\u00f1os o revise las instrucciones del producto. No sustituiremos el producto por otro.',
  'Enter an area and select a product to compare available pieces.':
    'Ingrese un \u00e1rea y seleccione un producto para comparar las piezas disponibles.',
  'Product area comparison only. Separate sheets are shown, not a wound layout. Area does not guarantee physical coverage. Clinicians determine trimming, placement and clinical suitability. Follow product instructions.':
    'Solo compara el \u00e1rea del producto. Se muestran l\u00e1minas separadas, no una distribuci\u00f3n sobre la herida. El \u00e1rea no garantiza cobertura f\u00edsica. El profesional determina el recorte, la colocaci\u00f3n y la idoneidad cl\u00ednica. Siga las instrucciones del producto.',

  'Page {page}': 'Página {page}',
  'Clear filters': 'Borrar filtros',
  'This file could not be processed. Choose a static PDF, PNG or JPEG without forms or active content.':
    'No se pudo procesar el archivo. Elija un PDF estático, PNG o JPEG sin formularios ni contenido activo.',
  'Keep editing': 'Seguir editando',
  'Discard changes': 'Descartar cambios',
  'Reload document?': '\u00bfVolver a cargar el documento?',
  'Discard unsaved changes?': '\u00bfDescartar los cambios sin guardar?',
  'A save may have completed. Check Drafts before adding this document again. Closing does not remove saved or published documents.':
    'Es posible que el documento ya se haya guardado. Revise Borradores antes de agregarlo de nuevo. Cerrar no elimina documentos guardados ni publicados.',
  'Only your unsaved edits will be discarded. Published documents are unchanged.':
    'Solo se descartar\u00e1n los cambios sin guardar. Los documentos publicados no cambian.',
  'The latest saved version will replace the fields in this editor.':
    'La versi\u00f3n guardada m\u00e1s reciente reemplazar\u00e1 los campos del editor.',
  'Discard & reload': 'Descartar y volver a cargar',
  'Select a product': 'Seleccione un producto',
  'Compare sizes within your product': 'Compare tama\u00f1os de su producto',
  'Enter the total coverage dimensions, including any overlap you determine. MedEffects adds no overlap.':
    'Ingrese las dimensiones totales de cobertura, incluido el solapamiento que usted determine. MedEffects no agrega solapamiento.',
  'Coverage length (cm)': 'Largo de cobertura (cm)',
  'Coverage width (cm)': 'Ancho de cobertura (cm)',
  'Total coverage area (cm\u00b2)': '\u00c1rea total de cobertura (cm\u00b2)',
  'Area alone cannot confirm a fit. Enter the total coverage length and width.':
    'El \u00e1rea sola no confirma el ajuste. Ingrese el largo y ancho totales de cobertura.',
  'Total coverage area estimate: {area} cm\u00b2':
    '\u00c1rea total estimada de cobertura: {area} cm\u00b2',
  'Size match': 'Tama\u00f1o compatible',
  'Your total coverage dimensions fit within this nominal product size. No extra overlap was added.':
    'Sus dimensiones totales de cobertura caben en este tama\u00f1o nominal del producto. No se agreg\u00f3 solapamiento adicional.',
  'Total coverage entered: {length} \u00d7 {width} cm':
    'Cobertura total ingresada: {length} \u00d7 {width} cm',
  'The dimensions fit with the length and width compared in swapped order. This is not an application instruction.':
    'Las dimensiones caben al comparar largo y ancho en orden inverso. Esto no es una instrucci\u00f3n de aplicaci\u00f3n.',
  'View size source': 'Ver fuente de dimensiones',
  'Your size match appears here': 'Su tama\u00f1o compatible aparecer\u00e1 aqu\u00ed',
  'Compare both total coverage dimensions with the product footprint, not just the area.':
    'Compare ambas dimensiones totales de cobertura con las dimensiones del producto, no solo el \u00e1rea.',
  'Dimension comparison only. You determine overlap and clinical suitability. Follow the product instructions. This does not determine treatment or insurance coverage.':
    'Solo comparaci\u00f3n de dimensiones. Usted determina el solapamiento y la idoneidad cl\u00ednica. Siga las instrucciones del producto. Esto no determina el tratamiento ni la cobertura del seguro.',
  '1 document': '1 documento',
  'Document published. All users can view it.':
    'Documento publicado. Todos los usuarios pueden verlo.',
  'A save may already have completed. Check Drafts before adding this document again. Leave the editor?':
    'Es posible que el documento ya se haya guardado. Revise Borradores antes de agregarlo de nuevo. ¿Salir del editor?',
  'Resources & Tools': 'Recursos y herramientas',
  'Product information and tools, all in one place.':
    'Información y herramientas de productos, en un solo lugar.',
  Documents: 'Documentos',
  'Size Finder': 'Tamaño de productos',
  'Document library': 'Biblioteca de documentos',
  'Manage documents': 'Administrar documentos',
  'View library': 'Ver biblioteca',
  'Add document': 'Agregar documento',
  'Edit document': 'Editar documento',
  'Document state': 'Estado del documento',
  All: 'Todos',
  Drafts: 'Borradores',
  Published: 'Publicado',
  Archived: 'Archivado',
  'Search documents': 'Buscar documentos',
  'Search titles or descriptions': 'Buscar títulos o descripciones',
  'All categories': 'Todas las categorías',
  'Product information': 'Información del producto',
  'Instructions for use': 'Instrucciones de uso',
  'Ordering guides': 'Guías de pedidos',
  'Loading Resources & Tools…': 'Cargando centro de recursos…',
  'Could not load Resources & Tools.': 'No se pudieron cargar los recursos y herramientas.',
  'Resources & Tools is not available yet.': 'El centro de recursos aún no está disponible.',
  'Loading documents…': 'Cargando documentos…',
  'Could not load documents. Please retry.':
    'No se pudieron cargar los documentos. Inténtelo de nuevo.',
  'No matching documents': 'No hay documentos que coincidan',
  'No documents here yet': 'Todavía no hay documentos',
  'Try another search or category.': 'Pruebe otra búsqueda o categoría.',
  'Add a document and review it before publishing.':
    'Agregue un documento y revíselo antes de publicarlo.',
  'Published resources will appear here.': 'Los recursos publicados aparecerán aquí.',
  'Unpublished changes': 'Cambios sin publicar',
  'Edit & preview': 'Editar y previsualizar',
  'View {title}': 'Ver {title}',
  'Download {title}': 'Descargar {title}',
  '{count} documents': '{count} documentos',
  'Document saved. Only published documents are shared.':
    'Documento guardado. Solo se comparten los documentos publicados.',
  'Document archived. Users can no longer access it in the app.':
    'Documento archivado. Los usuarios ya no pueden acceder a él en la aplicación.',
  'Document restored as a draft. Review and publish it to share again.':
    'Documento restaurado como borrador. Revíselo y publíquelo para compartirlo de nuevo.',
  'Archive document?': '¿Archivar documento?',
  'Restore document?': '¿Restaurar documento?',
  'This removes the document from the library. Copies already downloaded cannot be recalled.':
    'Esto elimina el documento de la biblioteca. Las copias ya descargadas no se pueden retirar.',
  'This returns the document to Drafts. It will not be shared until you review and publish it.':
    'Esto devuelve el documento a Borradores. No se compartirá hasta que lo revise y publique.',
  'Restore to drafts': 'Restaurar como borrador',
  'Publication review': 'Revisión de publicación',
  'Replace file (optional)': 'Reemplazar archivo (opcional)',
  'Document file': 'Archivo del documento',
  'PDF, PNG or JPEG · maximum 5 MB': 'PDF, PNG o JPEG · máximo 5 MB',
  'Uploads are currently unavailable. Existing document descriptions can still be edited.':
    'Las cargas no están disponibles. Puede editar las descripciones existentes.',
  'Uploading and preparing document… {progress}%': 'Cargando y preparando documento… {progress}%',
  'Reload document': 'Volver a cargar documento',
  'Preparing preview…': 'Preparando vista previa…',
  'Retry save': 'Reintentar guardar',
  'Save & preview': 'Guardar y previsualizar',
  'Saving creates a private draft. The current published version stays available until you publish a replacement.':
    'Guardar crea un borrador privado. La versión publicada sigue disponible hasta que publique un reemplazo.',
  'I reviewed this processed document and its description. It contains general resources, no patient or private clinic records, and can be shared with all users.':
    'Revisé este documento procesado y su descripción. Contiene recursos generales, no registros de pacientes ni información privada de clínicas, y puede compartirse con todos los usuarios.',
  'Publishing…': 'Publicando…',
  'Retry publish': 'Reintentar publicación',
  'Publish for all users': 'Publicar para todos',
  'Review before publishing': 'Revisar antes de publicar',
  'Save your draft to preview the processed file here. Nothing is shared until you publish.':
    'Guarde su borrador para ver el archivo procesado aquí. Nada se comparte hasta que publique.',
  'Leave this editor? Unsaved changes will be lost.':
    '¿Salir del editor? Los cambios sin guardar se perderán.',
  'Reload this document and discard unsaved changes?':
    '¿Volver a cargar el documento y descartar los cambios sin guardar?',
  'Add a title and choose a document.': 'Agregue un título y elija un documento.',
  'Choose a PDF, PNG or JPEG file no larger than 5 MB.':
    'Elija un archivo PDF, PNG o JPEG de hasta 5 MB.',
  'Check the document details and try again.':
    'Revise los datos del documento e inténtelo de nuevo.',
  'Your session ended. Sign in again.': 'Su sesión terminó. Inicie sesión de nuevo.',
  'You do not have access to this action.': 'No tiene acceso a esta acción.',
  'This document is no longer available. Refresh the library.':
    'Este documento ya no está disponible. Actualice la biblioteca.',
  'This document changed. Reload it before continuing.':
    'Este documento cambió. Vuelva a cargarlo antes de continuar.',
  'Choose a file no larger than 5 MB.': 'Elija un archivo de hasta 5 MB.',
  'Choose a supported static PDF, PNG or JPEG file.':
    'Elija un archivo estático compatible PDF, PNG o JPEG.',
  'Uploads are busy. Wait a moment and retry.':
    'Las cargas están ocupadas. Espere un momento e inténtelo de nuevo.',
  'Resources are temporarily unavailable. Please retry.':
    'Los recursos no están disponibles temporalmente. Inténtelo de nuevo.',
  'The request could not be confirmed. Please retry.':
    'No se pudo confirmar la solicitud. Inténtelo de nuevo.',
  Zoom: 'Ampliación',
  'Fit to width': 'Ajustar al ancho',
  'Fit entire image': 'Ajustar imagen completa',
  'Find a size within your product': 'Encuentre un tamaño para su producto',
  'Select your product, then enter the wound dimensions in centimetres.':
    'Seleccione su producto e ingrese las dimensiones de la herida en centímetros.',
  'Size Finder is not available yet. You can still browse documents.':
    'La herramienta de tamaños aún no está disponible. Puede consultar los documentos.',
  'Could not load products.': 'No se pudieron cargar los productos.',
  'Loading products…': 'Cargando productos…',
  'Primary product': 'Producto principal',
  'Verified sizing rules are not available yet. Product instructions remain available in Documents.':
    'Aún no hay reglas de tamaño verificadas. Las instrucciones del producto siguen disponibles en Documentos.',
  'I only know the area': 'Solo conozco el área',
  'Area (cm²)': 'Área (cm²)',
  'Area alone cannot confirm a fit. Enter length and width to receive a size suggestion.':
    'El área sola no confirma el ajuste. Ingrese largo y ancho para recibir una sugerencia.',
  'Length (cm)': 'Largo (cm)',
  'Width (cm)': 'Ancho (cm)',
  'Rectangular area estimate: {area} cm²': 'Estimación del área rectangular: {area} cm²',
  'Checking size…': 'Comprobando tamaño…',
  'Find size': 'Buscar tamaño',
  'Enter a length and width greater than 0 and up to 100 cm, with no more than two decimal places.':
    'Ingrese largo y ancho mayores de 0 y hasta 100 cm, con un máximo de dos decimales.',
  'Available sizes changed. Review the product and try again.':
    'Los tamaños disponibles cambiaron. Revise el producto e inténtelo de nuevo.',
  'Could not check the size. Please try again.':
    'No se pudo comprobar el tamaño. Inténtelo de nuevo.',
  'Suggested size': 'Tamaño sugerido',
  'Diagram showing the required dimensions within the suggested size':
    'Diagrama de las dimensiones requeridas dentro del tamaño sugerido',
  'Both dimensions fit within this verified size, including the configured coverage margin.':
    'Ambas dimensiones caben en este tamaño verificado, incluido el margen de cobertura configurado.',
  'Required dimensions: {length} × {width} cm': 'Dimensiones requeridas: {length} × {width} cm',
  'Rotate the product to fit these dimensions.':
    'Gire el producto para ajustarlo a estas dimensiones.',
  'Read product instructions': 'Leer instrucciones del producto',
  'Checking your measurements…': 'Comprobando sus medidas…',
  'No verified single-size match found': 'No se encontró un tamaño único verificado que se ajuste',
  'Sizing is unavailable for this product':
    'El cálculo de tamaño no está disponible para este producto',
  'Your size suggestion appears here': 'Su sugerencia de tamaño aparecerá aquí',
  'Review the product instructions or contact MedEffects. We will not substitute another product.':
    'Revise las instrucciones del producto o contacte a MedEffects. No sustituiremos otro producto.',
  'Use length and width to check both dimensions, not just the area.':
    'Use largo y ancho para comprobar ambas dimensiones, no solo el área.',
  'Sizing support only. This does not determine treatment suitability or insurance coverage. Follow the product instructions and your clinical judgment.':
    'Solo ayuda con el tamaño. No determina la idoneidad del tratamiento ni la cobertura del seguro. Siga las instrucciones del producto y su criterio clínico.',
  'Find your sizes': 'Encuentre sus tamaños',
  'Enter an area or length and width. We compare sizes within your selected product.':
    'Ingrese un área o largo y ancho. Comparamos tamaños del producto seleccionado.',
  'Measurement entry': 'Ingreso de medidas',
  'Area needed': 'Área necesaria',
  'Length & width': 'Largo y ancho',
  'Enter length and width greater than 0 and up to 100 cm, with no more than two decimal places.':
    'Ingrese largo y ancho mayores que 0 y hasta 100 cm, con un máximo de dos decimales.',
  'Calculated area: {area} cm²': 'Área calculada: {area} cm²',
  'Enter both measurements to calculate the area.': 'Ingrese ambas medidas para calcular el área.',
  'Length × width estimates a rectangular area; it does not verify sheet placement or wound shape.':
    'Largo × ancho estima un área rectangular; no verifica la colocación de las láminas ni la forma de la herida.',
  'Illustrative coverage layout — trimming may be needed':
    'Distribución ilustrativa; puede requerir recortes',
  'Combined area illustration with a dotted measurement outline':
    'Ilustración del área combinada con contorno punteado de las medidas',
  'Area-only reference square': 'Cuadrado de referencia solo para el área',
  '{area} cm² excess': '{area} cm² de exceso',
  '{area} cm² allocated ({percentage} of requested area)':
    '{area} cm² asignados ({percentage} del área solicitada)',
  'Colors show area allocated from each size, not intact sheet shapes. Multiple cuts may be needed. This is not a cutting guide or a guarantee of wound coverage.':
    'Los colores muestran el área asignada de cada tamaño, no la forma de láminas intactas. Pueden requerirse varios cortes. No es una guía de corte ni una garantía de cobertura de la herida.',
  'Product area comparison only. The layout is illustrative. Area does not guarantee physical coverage. Clinicians determine trimming, placement and clinical suitability. Follow product instructions.':
    'Solo comparación del área del producto. La distribución es ilustrativa. El área no garantiza la cobertura física. El profesional determina los recortes, la colocación y la idoneidad clínica. Siga las instrucciones del producto.',
  'Select a product and enter an area or length and width.':
    'Seleccione un producto e ingrese un área o largo y ancho.',
};

export default resourceCenter;
